module.exports = __webpack_public_path__ + "static/loviatar-DND3_FnP-a3f7824b7aaf59831aca5a297e00114b.webp";